import React from "react";
import { Container } from "./styles";
import infoIcon from "../../../assets/icons/InfoIcon.svg";
import { IoWarningOutline, IoCloseCircleOutline } from "react-icons/io5";
var InformationDiv = function (_a) {
    var title = _a.title, text = _a.text, containerStyles = _a.containerStyles, type = _a.type;
    var types = {
        info: {
            backgroundColor: "#e8f8ff",
            borderColor: "#01afff",
            icon: React.createElement("img", { src: infoIcon, style: { height: 40 } })
        },
        warning: {
            backgroundColor: "#fff9e8",
            borderColor: "#FFA814",
            icon: React.createElement(IoWarningOutline, { size: 40, color: "#FFA814" })
        },
        error: {
            backgroundColor: "#ffe8e8",
            borderColor: "#FF2C3A",
            icon: React.createElement(IoCloseCircleOutline, { size: 40, color: "#FF2C3A" })
        }
    };
    return (React.createElement(Container, { type: types[type], style: containerStyles },
        types[type].icon && types[type].icon,
        React.createElement("div", null,
            title && React.createElement("h2", null, title),
            text && React.createElement("span", null, text))));
};
InformationDiv.defaultProps = {
    title: undefined,
    text: undefined,
    containerStyles: undefined,
    type: "info"
};
export default InformationDiv;
//# sourceMappingURL=index.js.map